import api from './api';

interface VendedorInfo {
    nroVendedor: number;
    nombreVendedor?: string | null;
    telefono?: string | null;
    email?: string | null;
    direccion?: string | null;
}

interface CiudadInfo {
    codigoCiudad: number;
    nombreCiudad?: string | null;
    codigoProvincia?: number | null;
    codigoPostal?: string | null;
    nombreProvincia?: string | null;
}

interface ListaPrecioInfo {
    codigoLista: string;
    descripcion?: string | null;
}

interface Cliente {
    nroCliente: number;
    nombre: string;
    razonSocial?: string;
    direccion?: string;
    codigoCiudad?: number;
    telefono1?: string;
    telefono2?: string;
    fax?: string;
    email?: string;
    cuit?: string;
    dni?: string;
    tipoIva?: string;
    condVta?: string;
    credito?: number;
    nroLista?: string;
    contacto?: string;
    fechaAlta?: string;
    fechaBaja?: string;
    tipoCliente?: string;
    ctaMaestra?: number;
    nroCuenta?: number;
    deposito?: number;
    nroClienteExterno?: string;
    vendedor?: number;
    nroCobrador?: number;
    vtoComprob?: number | null;
    reDespacho?: number | null;
    porcDesc?: number;
    porcDesc2?: number;
    porcDesc3?: number;
    atributo1?: string;
    atributo2?: string;
    atributo3?: string;
    atributo4?: string;
    atributo5?: string;
    nroExpreso?: number | string | null;
    codigoDireccion?: string | null;
    codigoDireccionEnvio?: string | null;
    codigoDireccionResumen?: string | null;
    direccionEnvio?: string | null;
    codigoCiudadEnvio?: number | null;
    direccionResumen?: string | null;
    codigoCiudadResumen?: number | null;
    codigoRuta?: number | null;
    vendedorInfo?: VendedorInfo;
    ciudad?: CiudadInfo;
    listaPrecio?: ListaPrecioInfo;
    cobradorInfo?: VendedorInfo;
    cuentaContable?: {
        nroCuenta: number;
        nombreCuenta?: string;
    };
    depositoInfo?: {
        nroUbicacion: number;
        nombreUbicacion?: string;
        direccion?: string;
    };
    transporte?: {
        nroExpreso?: number | string;
        nombre?: string;
        nombreExpreso?: string;
    };
}

interface ClienteSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
}

interface ClientePagedResult {
    items: Cliente[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const clienteService = {
    getClientes: async (params: ClienteSearchParams): Promise<ClientePagedResult> => {
        const response = await api.get<ClientePagedResult>('/api/Clientes', { params });
        return response.data;
    },

    getCliente: async (nroCliente: number): Promise<Cliente> => {
        const response = await api.get<Cliente>(`/api/Clientes/${nroCliente}`);
        return response.data;
    },

    createCliente: async (cliente: any): Promise<Cliente> => {
        const response = await api.post<Cliente>('/api/Clientes', cliente);
        return response.data;
    },

    createClientesBulk: async (clientes: any[]): Promise<{ exitosos: number; fallidos: number; errores: { indice: number; nroCliente: number; mensaje: string }[] }> => {
        const response = await api.post<{ exitosos: number; fallidos: number; errores: { indice: number; nroCliente: number; mensaje: string }[] }>('/api/Clientes/Bulk', clientes);
        return response.data;
    },

    updateCliente: async (nroCliente: number, cliente: Cliente): Promise<void> => {
        await api.put(`/api/Clientes/${nroCliente}`, cliente);
    },

    deleteCliente: async (nroCliente: number): Promise<void> => {
        await api.delete(`/api/Clientes/${nroCliente}`);
    },

    getProximoNumero: async (): Promise<number> => {
        const response = await api.get<number>('/api/Clientes/ProximoNumero');
        return response.data;
    }
};

export default clienteService; 